import get from 'lodash/get';

import { ThemePalette } from '../types';

export default function getTheme(state: object): ThemePalette {
  return get(state, 'page.data.theme', null);
}
